/**
 * MRK Care Box – jQuery
 * v3: Inline upsell. Combine products merged as single summary row.
 */
(function ($) {
  'use strict';

  var $section = $('.mrk-care-box');
  if (!$section.length) return;

  var mrk_check = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAAQAElEQVR4AeydCax05xjHbwhCEGINQQhiizVIbal9r70tRe27oqh9X1uK2mstiqL2fV9bQmOpVAhCEKKWEIQg6v+fdm7nu3dm7jlnzvK+z/NrnufMzDnnXZ7fO///O/2++809xxb/QQACaQlgAGmXnsIhsLWFAfAugEBiAhhA4sWn9NwEXD0GYAokBJISwACSLjxlQ8AEMABTICGQlAAGkHThKTs3gXn1GMCcBI8QSEgAA0i46JQMgTkBDGBOgkcIJCSAASRcdErOTWCxegxgkQbPIZCMAAaQbMEpFwKLBDCARRo8h0AyAhhAsgWn3NwEdlaPAewkwmsIJCKAASRabEqFwE4CGMBOIryGQCICGECixabU3ASWVY8BLKPCOQgkIYABJFloyoTAMgIYwDIqnINAEgIYQJKFpszcBFZVjwGsIsN5CCQggAEkWGRKhMAqAhjAKjKch0ACAhhAgkWmxNwE1lWPAayjwzUIBCeAAQRfYMqDwDoCGMA6OlyDQHACGEDwBaa83AT2qh4D2IsQ1yEQmAAGEHhxKQ0CexHAAPYixHUIjEvgahruZOUZylOUD1YOFhjAYGjpGAKtCeyvFqcp91M6rqfDW5Q+r4d20eRuDKAJJe6BwPAELPIvrxjG5319xeXupzGA7uxoCYG+CNxcHVnkelgZvt67CWAAK3lzAQKjELD4v9RwpN5NAANoSJ7bIDAAgVuoz6bi162zaGQCszsbHDCABpC4BQIDELD4v9ix395MAAPouAI0g8AGBG6ptl3Fr6azsAm4n9mLrgcMoCs52kGgGwGL9gvdmu5q5X5uu+tsixMYQAtY3AqBDQncSu0tWj30Fp9RT3dUbkebJxhAG1rcC4HuBCz+z3dvvrblJ3T1LsrWgQG0RkYDCLQmcGu1GEr86noWH9HxHspWgQG0wsXNEGhNwOL/XOtW3RqcqGYHKRsHBtAYFTdCoDWB26jFWOLXUFtbOpygPETZKDCARpi4CQKtCVj8n23dqp8Gx6ubQ5V7BgawJyJugEBrAv6ruanEP5/scXryIOXawADW4uEiBFoTsPj9V3OtGw7Q4K3q82HKlYEBrETDBQi0JnA7tZhM/Bp7WRyrk49SLg0MYCkWTkKgNQGL/9OtW43T4HUa5jDlrsAAdiHhBARaEyhZ/PNijtGTw5X7BAawDw5eQKA1gdurRak7v6a2TxytV0cotwMD2EbBEwi0JmDxf6p1qwEatOjySN37dOUsMIAZBg4QaE3gDmpRm/g15Vm8SMdnK7cwAFMgIdCOgMX/yXZNirv7eZrRwRiAKBAQaEHA//S2dvHPyz0MA5ij4BECexOw+P1Pb/e+c8Q7NhhqPwxgA3o0TUXgTqo2kvhVztapGIAxkBBYT8Di//j6W6q8+gYMoMp1Y9IjErizxooo/ueqrjdiAKJAQGAFAYv/YyuuFXG64yQsfv8tAH8N2BEgzeITOEAlhha/6sMADIGEwA4CFv9Hd5yL8HJ7558Xw/8CzEnwCIEzCfjbdSOK/zkqb/axX4/bgQFso+AJBLYsfn+7bhUoWkzS4n/+svsxgGVUOJeRwF1VdCrxq17+DMAQyPQELP4PB6Tgf/CzdOef18ongDkJHrMSuJsKjyr+F6i2tYEBrMXDxeAELP4P1VjjHnP2zr+n+N0HBmAKZEYCd1fRqcWv+vkzAEMg0xGw+D8YsOpnqaZGO7/umwWfAGYYOCQiEFn8L2y7jhhAW2LcXzMB//bc6nf+JQvgnb+1+N0PBmAKZAYCFv+JAQvtLH6zwABMgYxO4J4qMKL4n6m6Ou38ajcLDGCGgUNgAhb/BwLWZ/H72303Kg0D2AgfjQsncC/NL5T4VY+jF/G7IwzAFMiIBCz+9wcsrDfxmw0GYApkNAIHqqCI4n+G6tr4Y7/62A4MYBsFT4IQsPjfF6SWxTIs/hcvnujjOQbQB0X6KIXAQZpIWPGrtt4DA+gdKR1ORMDiP2GisYcc1r/Is/edfz5hDGBOgseaCRysyUcV/0tU22CBAQyGlo5HImDxv3ekscYcxjv/oOJ3MRiAKZC1Eri3Jp5C/KpzkMAABsFKpyMQsPjfM8I4Yw/xNA04+M6vMWaBAcwwcKiMwH0036jif6lqGy0wgNFQM1BPBCz+d/fUV0ndeOcfVfwuHgMwBbIWAodoounEr5oHCwxgMLR03DMBi//4nvssobunahKj7/wacxYYwAwDh8IJ3Ffziyr+I1XbZIEBTIaegRsSsPjf1fDemm7zzj+p+A0LAzAFslQC6cU/9MJgAEMTpv+uBO6nhhF3/qeorsl3fs1hFhjADAOHwghY/O8sbE59TMfiP6qPjvrqAwPoiyT99EXg/uoI8QvCGIEBjEGZMZoSsPjf0fTmiu47QnNtvfOrzeCBAQyOmAEaEjhU90UV/8tUW5GBARS5LOkmZfEfF7Bq7/zFit+8xzCAi2mg/ZUXVRIQ2EngATqB+AVhihjaAPzXHaersC8r/6D0az0QEJgRsPjfPnsW6/BklbPRzq/2o8SQBuCvZfZHoMVC/NrnF8/xPCeBB6rsqOJ/uWqrIoYyAIvcv5hhGQSf9/Vl1ziXg4DF/7aApXrnr0b85j+EAVjcFrn7X5W+7vtWXed8XAIPUmmIXxBKiL4NwKK2uJvU5vt8f5N7uScGAYv/rTFK2aeKJ+lVbzu/+hot+jQAi9mibjN53+92bdpwb50EHqxpRxX/0aqtyujLACxii7kLBLdz+y5taVMHAYv/LXVMtdUsvfNXK35X2ocBWLwWsfvrmm7vfrq2p125BB6iqSF+QSgxNjUAi9bi7aM29+P++uiLPsogYPG/uYyp9DqLJ6q3QXZ+9TtqbGIAFqtF2+eE3Z/77bNP+pqGwEM1bFTxv0K1hYiuBmCRWqxDQHC/7n+IvulzHAIW/5vGGWrUUbzzhxG/yXUxAIvTInX7odL9e5yh+qff4Qg8TF1HFP/hqiuU+FXPVlsDsCgtTrcdOj2Oxxt6HPrvj4DFf2x/3RXTk8X/yqFnM0X/bQzAYrQox5ynx/O4Y47JWN0IIP5u3CZt1dQALEKLcYrJelyPP8XYjNmMgP+fn52/Gaui7mpiABafRTjlxD2+5zHlHBh7OQGLP+L/8z9B5Yb82K+6tmMvA7DoLL7tBhM+8Tw8nwmnwNA7CEQW/6t21Droy6k6X2cAFptFN9Xclo3r+Xhey65xblwC/iGfqDt/CvH77bLKACwyi833lJael+dX2rwyzcfij/hDPv7Yn0b8fsMuMwCLyyLz9VLT8/M8S51f5HlFFf/jtWipxK96d/0cgEVlcfla6el5er6lzzPS/Pyv+iLu/Bb/MVMt1JTjLn4CsJgsqinn03Zsz9fzbtuO+9sTsPgj/qu+tOL3W2BuABaRxeRztaXn7fnXNu+a5ov4a1qtFnO1Afjriy2iFs2Ku9XzxwSGWZao4n+ccKX82K+6t8MGcMD2q7qfYAL9r5+/wy/ix36L/9X942rf49QtbAAXn3oSPY6PCfQH0+KP+B1+iH/hPWID+NrC6whPMYHNVzGq+A8TGnZ+QZiHDeCo+YtAj5hA98X0L+2IuPNb/K/pjiVmSxvASSrtQGW0wATar6jFH/GXdhQp/vbL038LG4B7/YAOmIAgJA7En3Dx5wbg0jEBU8iZD1DZEXf+x6ouPvYLwqpYNADfgwmYQq60+CP+ll6L/7W5lrJ9tTsNwD1gAqaQIxH/ROtcyrDLDMBzwwRMIXYeqvLY+QUhc6wyADPBBEwhZlr8xwUs7TGqiY/9gtA01hmA+8AETCFWRhb/62It1fDV7GUAngEmYAox8v4qI+rOX434tQbFRBMD8GQxAVOoOy3+d9RdwtLZP1pnEb8gdImmBuC+MQFTqDMji//1dS5JGbNuYwCeMSZgCnXl/TTdqDs/4tfibhJtDcBjYQKmUEda/O+sY6qtZumP/VWKv1WVI9zcxQA8LUzAFMrOqOJ/lLAjfkHoI7oagMfGBEyhzIws/jeUibzOWW1iAK4YEzCFsvK+mk7Ej/3e+RG/FrfP2NQAPBdMwBTKSIv/XWVMpddZhBB/r0R66qwPA/BUMAFTmDajiv+RwsrOLwhDRF8G4LlhAqYwTR6iYSPu/Bb/G1UbMRCBPg3AU8QETGHctPiPH3fIUUZD/CNg7tsAPGVMwBTGScQ/DueNRym1gyEMwLViAqYwbN5H3Ufc+R+huvjYLwhjxFAG4LljAqYwTFr87x6m60l7tfiPnXQGyQYf0gCMEhMwhX4T8ffLM3VvQxuA4WICptBP3lvdRNz5H666wu78qq3YGMMAXDwmYAqbpcX/ns26KLK1xf+mImeWYFJjGYBRYgKm0C0RfzdutNqDwJgG4KlgAqbQLg/W7ez8gkD0T2BsA3AFmIApNEuL/73Nbq3qLv9pf4qP/aWvyhQGYCaYgCmsz8ji5w/81q/9aFenMgAXaBO4l58ES9f0/g1rOkjtI+78/vFexK/FLSWmNAAzOFGHeyqjxSYmYPGfEA2I6rH4+Qk/gSgppjYAs/igDndXRosuJoD4A70LaiilBAMwpw/rcDdltGhjAlHF7y/zYOcv9J1digEYz0d0uIsyWjQxgQNVdMSP/RY/X+ahxS01SjIAM/qYDgcoo8U6E7D43xetYNXjr+5G/AJRcpRmAGb1cR3urIwWy0wgsvhTf3V3LW/eEg3A7D6hwx2V0WLRBPw86s6P+Ct555ZqAMb3KR3uoIwWFr5/TsAZrbbHqCDELwi1RMkGYIaf1uF2ymhhE4hWk8XPb+mtbFVLNwDj/KwOt1US5RJ4rKaG+AXBUVPWYADm+TkdbqMkyiNg8b+2vGkxoyYEajEA1/J5HW6lJMohcJimgvgFodaoyQDM+Is63FJJTE/A4n/N9NNgBpsQqM0AXOuXdLi5kpiOAOJfwb620zUagBl/RYf9lcT4BB6nIdn5BSFC1GoAZv9VHW6mJMYjYPG/erzhGGloAjUbgNl8XYebKonhCTxeQyB+QYgUtRuA1+IbOtxESQxHwOI/ZrjuY/RcYxURDMDcT9LhRkqifwKIv3+mxfQYxQAM9Js67Kck+iPwBHXFzi8IUSOSAXiNvqXDDZXE5gQs/ldt3g09lEwgmgGY9bd1uIGS6E7gcDVF/ILQNGq9L6IBeC2+o8P1lUR7Ahb/K9s3o0WNBKIagNfiFB2upySaE0D8zVmFuDOyAXiBvqvDdZXE3gSeqFvY+QUhU0Q3AK/l93S4tpJYTcDif8Xqy1xZR6DmaxkMwOvzAx2upSR2E3iSTiF+QcgYWQzAa3uqDtdUEmcTsPiPPvslz7IRyGQAXtsf6nANJbG1hfh5F2xlMwAv+Wk6XF2ZOZ6s4tn5BWHTqL19RgPwmv1Ih6sqM4bF//KMhVPzbgJZDcAkfqzDVZSZ4ggVi/gFgTiTQGYDMIGf6HBlZYaw+F+WoVBqbE4guwGY1E91uJIyciD+AVY3QpcYwJmr+DM9XFEZRmJH3gAAA2dJREFUMZ6iotj5BYHYTQADOJvJz/X0CspIYfEfFakgaumXAAawL89f6OXllRHiqSoC8QsCsZoABrCbzS916nLKmsPiP7LmAkqfe5T5YQDLV/JXOn1ZZY2B+GtctYnmjAGsBv9rXbqMsqZ4mibLzi8IRDMCGMB6Tr/R5UsrawiL/6U1TJQ5lkMAA9h7LX6rWy6lLDmerskhfkEYIyKNgQE0W83f6bZLKksMi/8lJU6MOZVPAANovka/162XUJYUiL+k1ahwLhhAu0U7XbdfTFlCPEOTYOcXBKI7AQygPbs/qslFlVOGxf/iKSeQdexodWMA3Vb0T2p2EeUU8UwNivgFgdicAAbQneGf1fTCyjHD4n/RmAMyVmwCGMBm6/sXNb+QcoxA/GNQTjYGBrD5gv9VXVxQOWQ8S52z8wvClBFxbAygn1X9m7q5gHKIsPhfOETH9AkBDKC/98Df1dX5lX3Gs9UZ4hcEYhgCGEC/XP+h7s6n7CMs/hf00RF9QGAVAQxgFZnu5/+ppudVbhKIfxN6A7SN2iUGMMzK/kvdnkfZJZ6jRuz8gkAMTwADGI7xv9X1uZVtwuJ/fpsG3AuBTQhgAJvQ27vtf3TLuZRN4rm6CfELAjEeAQxgeNb/1RDnVK4Li/95627g2nQEIo+MAYyzuv/TMKtYI37BIaYhsOpNOc1sYo96hsrzPyU+WY/+mYHv69Hf28/OLxDENAQwgHG5+58S31hD+qcGr6NHvrdfEIjpCGAA07Fn5AoIRJ8iBhB9hakPAmsIYABr4HAJAtEJYADRV5j6ILCGAAawBg6XchPIUD0GkGGVqRECKwhgACvAcBoCGQhgABlWmRohsIIABrACDKdzE8hSPQaQZaWpEwJLCGAAS6BwCgJZCGAAWVaaOiGwhAAGsAQKp3ITyFQ9BpBptakVAjsIYAA7gPASApkIYACZVptaIbCDAAawAwgvcxPIVj0GkG3FqRcCCwQwgAUYPIVANgIYQLYVp14ILBDAABZg8DQ3gYzVYwAZV52aIXAWAQzgLBA8QCAjAQwg46pTMwTOIoABnAWCh9wEslaPAWRdeeqGgAhgAIJAQCArAQwg68pTNwREAAMQBCI3gczVYwCZV5/a0xPAANK/BQCQmQAGkHn1qT09AQwg/VsgN4Ds1f8fAAD//w3gfzAAAAAGSURBVAMAzDYEH0N7awMAAAAASUVORK5CYII=`;
  var mrk_empty = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==';

  var maxTotal         = parseInt($section.data('max-total') || 10, 10);
  var PRICE_CAP        = 4200; /* cents — €42 */
  var cart             = {};
  var inlineUpsellCart = {};
  var POPUP_UPSELL_ENABLED = false;
  var MAKE_WEBHOOK_URL = 'https://hook.eu2.make.com/guwc9tn46auxtihryqkmv6lgr1ufxb8e';

  /* Store the chosen variant per product (for multi-variant products) */
  var selectedVariants = {}; /* { productId: { variantId, title, price, sellingPlan } } */

  /* ========================================================
     HELPERS
     ======================================================== */
  function getTotalQty() {
    var t = 0;
    $.each(cart, function (_, v) { t += v.qty; });
    return t;
  }
  function getCartTotalPrice() {
    var t = 0;
    $.each(cart, function (_, v) { t += v.qty * (v.price || 0); });
    return t;
  }
  function esc(str) {
    return $('<span>').text(str).html();
  }

  /* Can this card afford to be incremented by 1?  (price-check only, not qty) */
  function cardFitsInBudget($card) {
    var p = parseFloat($card.data('price') || 0);
    if (p <= 0) return true;
    return (getCartTotalPrice() + p) <= PRICE_CAP;
  }

  /* Cart is "full" = no main product card can accept another unit.
     That's true iff qty-cap is hit OR every card that still has per-product
     capacity would blow the price cap. */
  function isCartFull() {
    if (getTotalQty() >= maxTotal) return true;
    var anyRoom = false;
    $section.find('.mrk-product-card:not(.mrk-upsell-inline-card)').each(function () {
      var $c    = $(this);
      var pid   = $c.data('product-id');
      var qty   = cart[pid] ? cart[pid].qty : 0;
      var maxQ  = parseInt($c.data('max-qty') || 10, 10);
      if (qty >= maxQ) return;                 /* this card is individually maxed; skip */
      if (cardFitsInBudget($c)) { anyRoom = true; return false; }
    });
    return !anyRoom;
  }

  function updateProgress() {
    var totalQty   = getTotalQty();
    var totalPrice = getCartTotalPrice();
    var full       = isCartFull();
    var pct        = full
                     ? 100
                     : Math.max(
                         Math.min((totalQty   / maxTotal)  * 100, 100),
                         Math.min((totalPrice / PRICE_CAP) * 100, 100)
                       );
    $section.find('.mrk-progress__fill').css('width', pct + '%');
    var $h = $section.find('.mrk-progress__hint');
    $h.text(full ? $h.data('full-text') : $h.data('default-text'));
  }

  function parseSize(rawSize, rawStock) {
    if (rawSize) {
      var m = rawSize.match(/^([\d.,]+)\s*(.*)$/);
      if (m) return { value: parseFloat(m[1].replace(',', '.')), unit: m[2].trim() || 'ml' };
      return { value: 1, unit: 'ml' };
    }
    if (rawStock) {
      var n = parseFloat(String(rawStock).replace(',', '.'));
      return { value: isNaN(n) ? 1 : n, unit: 'Stk.' };
    }
    return { value: 1, unit: '' };
  }

  function syncCard(pid) {
    var $card = $section.find('[data-product-id="' + pid + '"]');
    var qty   = cart[pid] ? cart[pid].qty : 0;
    $card.find('.mrk-qty-value').first().text(qty);
    $card.find('.mrk-product-card__badge-num').text(qty);
    if (qty > 0) {
      $card.addClass('mrk-product-card--selected').find('.mrk-product-card__badge').not('.mrk-upsell-inline-badge').show();
    } else {
      $card.removeClass('mrk-product-card--selected').find('.mrk-product-card__badge').not('.mrk-upsell-inline-badge').hide();
    }

    /* Show selected variant name under product name (for multi-variant cards) */
    var sel = selectedVariants[pid];
    var $variantNote = $card.find('.mrk-product-card__variant-selected');
    if (sel && sel.title) {
      if (!$variantNote.length) {
        $card.find('.mrk-product-card__body').append('<p class="mrk-product-card__variant-selected"></p>');
        $variantNote = $card.find('.mrk-product-card__variant-selected');
      }
      $variantNote.text(sel.title);
    } else {
      $variantNote.remove();
    }

    $card.find('.mrk-qty-btn--minus').prop('disabled', qty <= 0);

    var maxQ       = parseInt($card.data('max-qty') || 10, 10);
    var qtyCapped  = qty >= maxQ || getTotalQty() >= maxTotal;
    var priceOK    = cardFitsInBudget($card);

    /* Per-card "Auswahl nicht möglich" overlay: shown only when qty is 0 AND
       the next unit would push the cart over the €42 cap. Cards already in the
       cart keep their +/- behavior (minus still works). */
    var showUnavail = qty === 0 && !priceOK;
    $card.toggleClass('mrk-product-card--unavailable', showUnavail);
    $card.find('.mrk-product-card__unavailable').toggle(showUnavail);

    $card.find('.mrk-qty-btn--plus').prop('disabled', qtyCapped || !priceOK);
  }
  function syncCartSidebarBtns() {
    $('#mrk-cart-items').find('.mrk-cart-item').each(function () {
      var pid       = $(this).data('cart-pid');
      var $card     = $section.find('[data-product-id="' + pid + '"]');
      var qty       = cart[pid] ? cart[pid].qty : 0;
      var maxQ      = parseInt($card.data('max-qty') || 10, 10);
      var priceOK   = cardFitsInBudget($card);
      $(this).find('.mrk-cart-plus').prop('disabled', qty >= maxQ || getTotalQty() >= maxTotal || !priceOK);
    });
  }
  function syncAllPlusBtns() {
    $section.find('.mrk-product-card').not('.mrk-upsell-inline-card').each(function () {
      syncCard($(this).data('product-id'));
    });
  }

  function syncInlineUpsellCard(pid) {
    var $card = $section.find('[data-upsell-inline-id="' + pid + '"]');
    var qty   = inlineUpsellCart[pid] ? inlineUpsellCart[pid].qty : 0;
    $card.find('.mrk-upsell-inline-qty').text(qty);
    $card.find('.mrk-upsell-inline-badge-num').text(qty);
    if (qty > 0) {
      $card.addClass('mrk-product-card--selected').find('.mrk-upsell-inline-badge').show();
    } else {
      $card.removeClass('mrk-product-card--selected').find('.mrk-upsell-inline-badge').hide();
    }
    $card.find('.mrk-upsell-inline-minus').prop('disabled', qty <= 0);
    var maxQ = parseInt($card.data('upsell-inline-max') || 4, 10);
    $card.find('.mrk-upsell-inline-plus').prop('disabled', qty >= maxQ);
  }

  function syncAllInlineUpsellCards() {
    $section.find('.mrk-upsell-inline-card').each(function () {
      syncInlineUpsellCard($(this).data('upsell-inline-id'));
    });
  }

  function buildCartItemHtml(pid, item, removeClass, plusClass) {
    var detail = 'Qty: ' + item.qty;
    if (item.variantTitle) detail = item.variantTitle + ' · Qty: ' + item.qty;
    return (
      '<div class="mrk-cart-item" data-cart-pid="' + pid + '">' +
        (item.img ? '<img src="' + item.img + '" alt="' + esc(item.title) + '" class="mrk-cart-item__img">' : '') +
        '<div class="mrk-cart-item__body">' +
          '<p class="mrk-cart-item__name">' + esc(item.title) + '</p>' +
          '<p class="mrk-cart-item__detail">' + esc(detail) + '</p>' +
        '</div>' +
        '<div class="mrk-cart-item__controls">' +
          '<button type="button" class="mrk-qty-btn ' + removeClass + '" aria-label="Remove">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>' +
          '</button>' +
          '<span class="mrk-qty-value">' + item.qty + '</span>' +
          '<button type="button" class="mrk-qty-btn ' + plusClass + '" aria-label="Add">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function renderCart() {
    var $c  = $('#mrk-cart-items');
    $c.empty();
    var any = false;
    $.each(cart, function (pid, item) {
      if (item.qty <= 0) return;
      any = true;
      $c.append(buildCartItemHtml(pid, item, 'mrk-cart-remove', 'mrk-cart-plus'));
    });
    if (!any) {
      $c.html('<p class="mrk-cart-items__empty">' + ($c.data('empty-text') || 'No products selected yet.') + '</p>');
    }
    renderUpsellSidebar();
    updateProgress();
    syncCartSidebarBtns();
  }

  function renderUpsellSidebar() {
    var $sidebar = $('#mrk-upsell-sidebar');
    var $c       = $('#mrk-upsell-cart-items');
    $c.empty();
    var any = false;
    $.each(inlineUpsellCart, function (pid, item) {
      if (item.qty <= 0) return;
      any = true;
      $c.append(buildCartItemHtml(pid, item, 'mrk-upsell-cart-remove', 'mrk-upsell-cart-plus'));
    });
    $sidebar.toggle(any);
  }

  /* ========================================================
     VARIANT PICKER (gloves sizes etc.)
     ======================================================== */
  function getCardVariants($card) {
    var raw = $card.attr('data-variants');
    if (!raw) return [];
    try { return JSON.parse(raw) || []; } catch (err) { return []; }
  }

  /* Open the picker for a given card; invoke cb(variant) when user picks. */
  function openVariantPicker($card, cb) {
    var variants = getCardVariants($card);
    var $opts    = $('#mrk-variant-overlay-options').empty();

    $('#mrk-variant-overlay-title').text($card.data('product-title') || '');

    $.each(variants, function (_, v) {
      var disabled = v.available === false;
      var $btn = $('<button type="button" class="mrk-variant-option"></button>')
        .text(v.title)
        .prop('disabled', disabled)
        .on('click', function (e) {
          e.stopPropagation();
          $('#mrk-variant-overlay').fadeOut(150);
          $('body').css('overflow', '');
          cb(v);
        });
      $opts.append($btn);
    });

    $('#mrk-variant-overlay').fadeIn(180);
    $('body').css('overflow', 'hidden');
  }

  $(document).on('click', '[data-variant-close]', function () {
    $('#mrk-variant-overlay').fadeOut(150);
    $('body').css('overflow', '');
  });

  /* ========================================================
     MAIN PRODUCT CARD – PLUS
     ======================================================== */
  function incrementMainCard($card, chosenVariant) {
    var pid  = $card.data('product-id');
    var maxQ = parseInt($card.data('max-qty') || 10, 10);

    /* If a variant was chosen, persist it for this product */
    if (chosenVariant) {
      selectedVariants[pid] = {
        variantId:   chosenVariant.id,
        title:       chosenVariant.title,
        price:       chosenVariant.price,
        sellingPlan: chosenVariant.selling_plan_id || ''
      };
    }

    var sel = selectedVariants[pid];

    if (!cart[pid]) {
      cart[pid] = {
        handle:        $card.data('product-handle'),
        title:         $card.data('product-title'),
        variantId:     sel ? sel.variantId   : $card.data('variant-id'),
        variantTitle:  sel ? sel.title       : '',
        sellingPlan:   sel ? sel.sellingPlan : ($card.data('selling-plan') || ''),
        qty:           0,
        price:         parseFloat(($card.data('price') || 0)),
        img:           $card.find('.mrk-product-card__image img').attr('src') || ''
      };
    }

    if (cart[pid].qty < maxQ && getTotalQty() < maxTotal && cardFitsInBudget($card)) {
      cart[pid].qty++;
      syncAllPlusBtns();
      renderCart();
    }
  }

  $section.on('click', '.mrk-product-card:not(.mrk-upsell-inline-card) .mrk-qty-btn--plus', function (e) {
    e.stopPropagation();
    var $card = $(this).closest('.mrk-product-card');
    var pid   = $card.data('product-id');

    /* Pre-flight checks (budget / qty cap) */
    var maxQ  = parseInt($card.data('max-qty') || 10, 10);
    var qty   = cart[pid] ? cart[pid].qty : 0;
    if (qty >= maxQ || getTotalQty() >= maxTotal || !cardFitsInBudget($card)) return;

    var hasVariants = String($card.data('has-variants')).toLowerCase() === 'true';

    /* Multi-variant product: ask on first add (when nothing chosen yet) */
    if (hasVariants && !selectedVariants[pid]) {
      openVariantPicker($card, function (variant) {
        incrementMainCard($card, variant);
      });
      return;
    }

    incrementMainCard($card);
  });

  $section.on('click', '.mrk-product-card:not(.mrk-upsell-inline-card) .mrk-qty-btn--minus', function (e) {
    e.stopPropagation();
    var $card = $(this).closest('.mrk-product-card');
    var pid   = $card.data('product-id');
    if (cart[pid] && cart[pid].qty > 0) {
      cart[pid].qty--;
      if (cart[pid].qty <= 0) {
        delete cart[pid];
        delete selectedVariants[pid];  /* clear so popup re-opens next time */
      }
      syncAllPlusBtns();
      renderCart();
    }
  });

  $section.on('click', '.mrk-cart-remove', function () {
    var pid = $(this).closest('.mrk-cart-item').data('cart-pid');
    if (cart[pid]) {
      cart[pid].qty--;
      if (cart[pid].qty <= 0) {
        delete cart[pid];
        delete selectedVariants[pid];
      }
      syncAllPlusBtns();
      renderCart();
    }
  });

  $section.on('click', '.mrk-cart-plus', function () {
    var pid   = $(this).closest('.mrk-cart-item').data('cart-pid');
    var $card = $section.find('[data-product-id="' + pid + '"]');
    var maxQ  = parseInt($card.data('max-qty') || 10, 10);
    if (cart[pid] && cart[pid].qty < maxQ && getTotalQty() < maxTotal && cardFitsInBudget($card)) {
      cart[pid].qty++;
      syncAllPlusBtns();
      renderCart();
    }
  });

  $section.on('click', '.mrk-upsell-inline-card .mrk-upsell-inline-plus', function (e) {
    e.stopPropagation();
    var $card = $(this).closest('.mrk-upsell-inline-card');
    var pid   = $card.data('upsell-inline-id');
    var maxQ  = parseInt($card.data('upsell-inline-max') || 4, 10);
    if (!inlineUpsellCart[pid]) {
      inlineUpsellCart[pid] = {
        handle:   $card.data('upsell-inline-handle'),
        title:    $card.data('upsell-inline-title'),
        variantId:$card.data('variant-id'),
        qty:      0,
        img:      $card.find('.mrk-product-card__image img').attr('src') || '',
        rawSize:  String($card.data('size')  || '').trim(),
        rawStock: String($card.data('stock') || '').trim()
      };
    }
    if (inlineUpsellCart[pid].qty < maxQ) {
      inlineUpsellCart[pid].qty++;
      syncInlineUpsellCard(pid);
      renderUpsellSidebar();
    }
  });

  $section.on('click', '.mrk-upsell-inline-card .mrk-upsell-inline-minus', function (e) {
    e.stopPropagation();
    var $card = $(this).closest('.mrk-upsell-inline-card');
    var pid   = $card.data('upsell-inline-id');
    if (inlineUpsellCart[pid] && inlineUpsellCart[pid].qty > 0) {
      inlineUpsellCart[pid].qty--;
      if (inlineUpsellCart[pid].qty <= 0) delete inlineUpsellCart[pid];
      syncInlineUpsellCard(pid);
      renderUpsellSidebar();
    }
  });

  $section.on('click', '.mrk-upsell-cart-remove', function () {
    var pid = $(this).closest('.mrk-cart-item').data('cart-pid');
    if (inlineUpsellCart[pid]) {
      inlineUpsellCart[pid].qty--;
      if (inlineUpsellCart[pid].qty <= 0) delete inlineUpsellCart[pid];
      syncInlineUpsellCard(pid);
      renderUpsellSidebar();
    }
  });

  $section.on('click', '.mrk-upsell-cart-plus', function () {
    var pid   = $(this).closest('.mrk-cart-item').data('cart-pid');
    var $card = $section.find('[data-upsell-inline-id="' + pid + '"]');
    var maxQ  = parseInt($card.data('upsell-inline-max') || 4, 10);
    if (inlineUpsellCart[pid] && inlineUpsellCart[pid].qty < maxQ) {
      inlineUpsellCart[pid].qty++;
      syncInlineUpsellCard(pid);
      renderUpsellSidebar();
    }
  });

  $section.on('click', '[data-info-trigger]', function (e) {
    e.stopPropagation();
    var html = $(this).closest('.mrk-product-card').find('[data-info-content]').html();
    $('#mrk-overlay-dialog').html(html);
    $('#mrk-overlay').fadeIn(200);
  });

  $(document).on('click', '.mrk-info-dialog__close, .mrk-overlay__backdrop', function () {
    $('#mrk-overlay').fadeOut(200);
  });

  function goToStep(n) {
    $section.find('.mrk-stepper__step').each(function () {
      var s = parseInt($(this).data('step'), 10);
      $(this).removeClass('mrk-stepper__step--active mrk-stepper__step--done');
      if (s === n)      $(this).addClass('mrk-stepper__step--active');
      else if (s < n)   $(this).addClass('mrk-stepper__step--done');
    });
    $section.find('.mrk-stepper__line').each(function (i) {
      $(this).toggleClass('mrk-stepper__line--active', i < n - 1);
    });
    $section.find('[data-step-content]').hide();
    var $target = $section.find('[data-step-content="' + n + '"]');
    $target.show().css('animation', 'none');
    setTimeout(function () { $target.css('animation', ''); }, 10);
    $('html, body').animate({ scrollTop: $section.offset().top - 20 }, 300);
  }

  $section.on('click', '#mrk-btn-step2, #mrk-btn-step2-mobile', function () {
    if (getTotalQty() === 0) { alert('Please select at least one product.'); return; }
    if (POPUP_UPSELL_ENABLED && $('#mrk-upsell-overlay').length && $section.find('.mrk-upsell-card').length) {
      openUpsell();
    } else if ($section.find('.mrk-upsell-inline').length && Object.keys(inlineUpsellCart).length === 0) {
      openInlineUpsellPopup();
    } else {
      goToStep(2);
    }
  });

  $section.on('click', '#mrk-back-step1', function (e) {
    e.preventDefault();
    goToStep(1);
  });

  var upsellCart = {};

  function openUpsell() {
    resetUpsellQtys();
    $('#mrk-upsell-overlay').fadeIn(220);
    $('body').css('overflow', 'hidden');
  }

  function closeUpsell() {
    $('#mrk-upsell-overlay').fadeOut(180);
    $('body').css('overflow', '');
  }

  function resetUpsellQtys() {
    upsellCart = {};
    $section.find('.mrk-upsell-card').each(function () {
      $(this).find('.mrk-upsell-qty-value').text(0);
      $(this).find('.mrk-upsell-minus').prop('disabled', true);
      $(this).find('.mrk-upsell-plus').prop('disabled', false);
    });
    syncUpsellConfirmBtn();
  }

  function syncUpsellConfirmBtn() {
    var anySelected = Object.keys(upsellCart).some(function (k) { return upsellCart[k].qty > 0; });
    $('#mrk-upsell-confirm').toggle(anySelected);
    $('#mrk-upsell-skip').toggleClass('mrk-btn--upsell-skip--alone', !anySelected);
  }

  var $inlineUpsellEl      = null;
  var $inlineUpsellBackdrop = null;
  var $inlineUpsellSheet    = null;

  function openInlineUpsellPopup() {
    $inlineUpsellEl = $section.find('.mrk-upsell-inline');
    if (!$inlineUpsellEl.length) { goToStep(2); return; }

    if (!$inlineUpsellEl.find('.mrk-upsell-inline__sheet').length) {
      $inlineUpsellEl.wrapInner('<div class="mrk-upsell-inline__sheet"></div>');
    }
    $inlineUpsellSheet = $inlineUpsellEl.find('.mrk-upsell-inline__sheet');

    if (!$inlineUpsellEl.find('.mrk-upsell-inline__backdrop').length) {
      $inlineUpsellEl.prepend('<div class="mrk-upsell-inline__backdrop"></div>');
    }
    $inlineUpsellBackdrop = $inlineUpsellEl.find('.mrk-upsell-inline__backdrop');

    $inlineUpsellEl.find('#mrk-upsell-inline-close').show();
    $inlineUpsellEl.find('.mrk-upsell-inline__popup-footer').show();

    $inlineUpsellEl.addClass('mrk-upsell-inline--popup');
    $('body').css('overflow', 'hidden');
    $('html, body').animate({ scrollTop: 0 }, 0);
  }

  function closeInlineUpsellPopup(proceed) {
    if (!$inlineUpsellEl || !$inlineUpsellEl.length) { if (proceed) goToStep(2); return; }
    $inlineUpsellEl.removeClass('mrk-upsell-inline--popup');
    $inlineUpsellEl.find('#mrk-upsell-inline-close').hide();
    $inlineUpsellEl.find('.mrk-upsell-inline__popup-footer').hide();
    $('body').css('overflow', '');
    if (proceed) goToStep(2);
  }

  $section.on('click', '#mrk-upsell-inline-close, #mrk-upsell-inline-skip', function () {
    closeInlineUpsellPopup(true);
  });

  $section.on('click', '#mrk-upsell-inline-confirm', function () {
    closeInlineUpsellPopup(true);
  });

  $section.on('click', '.mrk-upsell-inline__backdrop', function () {
    closeInlineUpsellPopup(true);
  });

  function mergeUpsellIntoCart() {
    $.each(upsellCart, function (pid, item) {
      if (item.qty <= 0) return;
      if (!cart[pid]) cart[pid] = { handle: '', title: item.title, qty: 0, img: item.img };
      cart[pid].qty += item.qty;
      var total = getTotalQty();
      if (total > maxTotal) {
        cart[pid].qty -= (total - maxTotal);
        if (cart[pid].qty <= 0) delete cart[pid];
      }
    });
    syncAllPlusBtns();
    renderCart();
  }

  $section.on('click', '.mrk-upsell-plus', function () {
    var $card = $(this).closest('.mrk-upsell-card');
    var pid   = $card.data('upsell-id');
    var maxQ  = parseInt($card.data('upsell-max') || 4, 10);
    if (!upsellCart[pid]) {
      upsellCart[pid] = { title: $card.data('upsell-title'), img: $card.find('.mrk-upsell-card__image').attr('src') || '', qty: 0 };
    }
    if (upsellCart[pid].qty < maxQ) {
      upsellCart[pid].qty++;
      $card.find('.mrk-upsell-qty-value').text(upsellCart[pid].qty);
      $card.find('.mrk-upsell-minus').prop('disabled', false);
      if (upsellCart[pid].qty >= maxQ) $card.find('.mrk-upsell-plus').prop('disabled', true);
    }
    syncUpsellConfirmBtn();
  });

  $section.on('click', '.mrk-upsell-minus', function () {
    var $card = $(this).closest('.mrk-upsell-card');
    var pid   = $card.data('upsell-id');
    if (upsellCart[pid] && upsellCart[pid].qty > 0) {
      upsellCart[pid].qty--;
      $card.find('.mrk-upsell-qty-value').text(upsellCart[pid].qty);
      $card.find('.mrk-upsell-plus').prop('disabled', false);
      if (upsellCart[pid].qty <= 0) { $card.find('.mrk-upsell-minus').prop('disabled', true); delete upsellCart[pid]; }
    }
    syncUpsellConfirmBtn();
  });

  $section.on('click', '#mrk-upsell-skip',    function () { closeUpsell(); goToStep(2); });
  $section.on('click', '#mrk-upsell-confirm', function () { mergeUpsellIntoCart(); closeUpsell(); goToStep(2); });
  $section.on('click', '.mrk-upsell-overlay__backdrop', function () { closeUpsell(); goToStep(2); });

  $section.on('click', '#mrk-upsell-info-toggle', function () {
    var $btn  = $(this);
    var $body = $('#mrk-upsell-info-body');
    var open  = $btn.attr('aria-expanded') === 'true';
    $btn.attr('aria-expanded', String(!open));
    $btn.find('.mrk-upsell__chevron').css('transform', open ? '' : 'rotate(180deg)');
    open ? $body.slideUp(180) : $body.slideDown(180);
  });

  $section.on('click', '#mrk-upsell-inline-info-toggle', function () {
    var $btn  = $(this);
    var $body = $('#mrk-upsell-inline-info-body');
    var open  = $btn.attr('aria-expanded') === 'true';
    $btn.attr('aria-expanded', String(!open));
    $btn.find('.mrk-upsell__chevron').css('transform', open ? '' : 'rotate(180deg)');
    open ? $body.slideUp(180) : $body.slideDown(180);
  });

  $section.on('change', '#mrk-delivery-address', function () {
    $(this).is(':checked') ? $('#mrk-delivery-fields').slideDown(200) : $('#mrk-delivery-fields').slideUp(200);
  });

  /* Date fields use native type="date" (YYYY-MM-DD). We convert to DD.MM.YYYY
     at payload build time so Make.com / downstream formatting stays the same. */
  function yyyymmddToDmy(v) {
    if (!v) return '';
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
    return m ? (m[3] + '.' + m[2] + '.' + m[1]) : v;
  }

  $section.on('change', 'input[name="consultation"]', function () {
    $section.find('.mrk-radio__note').slideUp(150);
    $(this).closest('.mrk-radio-wrap').find('.mrk-radio__note').slideDown(150);
  });

  $section.on('change', '#mrk-insurance', function () {
    if ($(this).val() === 'other') { $('#mrk-insurance-other').slideDown(200); }
    else { $('#mrk-insurance-other').slideUp(200); $('#mrk-insurance-custom').val(''); }
  });

  $section.on('change', '#mrk-change-provider', function () {
    if ($(this).is(':checked')) { $('#mrk-provider-fields').slideDown(200); }
    else { $('#mrk-provider-fields').slideUp(200); $('#mrk-current-provider').val(''); }
  });

  (function () {
    $section.find('.mrk-radio__note').hide();
    $section.find('input[name="consultation"]:checked').closest('.mrk-radio-wrap').find('.mrk-radio__note').show();
  })();

  var signatureCanvas = document.getElementById('mrk-signature-canvas');
  var signatureCtx    = signatureCanvas ? signatureCanvas.getContext('2d') : null;
  var isDrawing       = false;
  var signatureEmpty  = true;

  function getPos(e, canvas) {
    var rect   = canvas.getBoundingClientRect();
    var scaleX = canvas.width  / rect.width;
    var scaleY = canvas.height / rect.height;
    var clientX = e.touches ? e.touches[0].clientX : e.clientX;
    var clientY = e.touches ? e.touches[0].clientY : e.clientY;
    return { x: (clientX - rect.left) * scaleX, y: (clientY - rect.top) * scaleY };
  }

  if (signatureCanvas && signatureCtx) {
    signatureCtx.strokeStyle = '#1a2e3b';
    signatureCtx.lineWidth   = 2;
    signatureCtx.lineCap     = 'round';
    signatureCtx.lineJoin    = 'round';

    function startDraw(e) { e.preventDefault(); isDrawing = true; signatureEmpty = false; var pos = getPos(e, signatureCanvas); signatureCtx.beginPath(); signatureCtx.moveTo(pos.x, pos.y); }
    function draw(e)      { if (!isDrawing) return; e.preventDefault(); var pos = getPos(e, signatureCanvas); signatureCtx.lineTo(pos.x, pos.y); signatureCtx.stroke(); }
    function endDraw(e)   { if (!isDrawing) return; e.preventDefault(); isDrawing = false; signatureCtx.beginPath(); }

    signatureCanvas.addEventListener('mousedown',  startDraw);
    signatureCanvas.addEventListener('mousemove',  draw);
    signatureCanvas.addEventListener('mouseup',    endDraw);
    signatureCanvas.addEventListener('mouseleave', endDraw);
    signatureCanvas.addEventListener('touchstart', startDraw, { passive: false });
    signatureCanvas.addEventListener('touchmove',  draw,      { passive: false });
    signatureCanvas.addEventListener('touchend',   endDraw,   { passive: false });
  }

  $section.on('click', '#mrk-signature-clear', function () {
    if (signatureCtx) { signatureCtx.clearRect(0, 0, signatureCanvas.width, signatureCanvas.height); signatureEmpty = true; }
  });

  function buildPayload() {
    var $form = $('#mrk-care-form');

    var products = {};
    $section.find('.mrk-product-card:not(.mrk-upsell-inline-card)').each(function () {
      var pid = String($(this).data('product-id'));
      var idx = $(this).data('product-index');
      if (cart[pid] && cart[pid].qty > 0) {
        products['product_' + idx] = cart[pid].qty;
      }
    });

    var summaryItems  = {};
    var combineTotal  = 0;
    var combineUnit   = '';

    $section.find('.mrk-product-card:not(.mrk-upsell-inline-card)').each(function () {
      var pid = String($(this).data('product-id'));
      if (!cart[pid] || cart[pid].qty <= 0) return;

      var idx       = $(this).data('summary-index');
      var rawSize   = String($(this).data('size')  || '').trim();
      var rawStock  = String($(this).data('stock') || '').trim();
      var isCombine = String($(this).data('combine')).toLowerCase() === 'true';
      var qty       = cart[pid].qty;
      var parsed    = parseSize(rawSize, rawStock);
      var total     = qty * parsed.value;

      if (isCombine) {
        combineTotal += total;
        if (!combineUnit) combineUnit = parsed.unit;
      } else {
        summaryItems['item_' + idx] = total + (parsed.unit ? ' ' + parsed.unit : '');
      }
    });

    if (combineTotal > 0) {
      summaryItems['item_combined'] = combineTotal + (combineUnit ? ' ' + combineUnit : '');
    }

    var additionalProducts        = {};
    var additionalProductsSummary = {};
    var ui = 1;
    $.each(inlineUpsellCart, function (pid, item) {
      if (item.qty > 0) {
        var parsed = parseSize(item.rawSize, item.rawStock);
        var total  = item.qty * parsed.value;
        additionalProducts['upsell_' + ui]               = item.qty;
        additionalProductsSummary['summary_upsell_' + ui] = total + (parsed.unit ? ' ' + parsed.unit : '');
        ui++;
      }
    });

    var insuranceRawSelection = $form.find('#mrk-insurance').val();
    var insuranceIsOther      = insuranceRawSelection === 'other';
    var insuranceCompany      = insuranceRawSelection;
    if (insuranceIsOther) {
      insuranceCompany = $form.find('#mrk-insurance-custom').val() || 'Other';
    }

    /* Convert native date-picker values (YYYY-MM-DD) to DD.MM.YYYY for
       downstream systems that expect the German format. */
    var birthdateDmy     = yyyymmddToDmy($form.find('#mrk-birthdate').val());
    var signatureDateDmy = yyyymmddToDmy($form.find('#mrk-signature-date').val());

    var signatureDataUrl = '';
    if (signatureCanvas && !signatureEmpty) {
      signatureDataUrl = signatureCanvas.toDataURL('image/png');
    }

    var cgZipCity        = ($form.find('#mrk-cg-zip-city').val() || '').trim();
    var cgZip            = cgZipCity.match(/^\d+/) ? cgZipCity.match(/^\d+/)[0] : '';
    var cgCity           = cgZipCity.replace(/^\d+\s*/, '').trim();
    var differentDelivery = $form.find('#mrk-delivery-address').is(':checked');

    var lineItems = [];
    $section.find('.mrk-product-card:not(.mrk-upsell-inline-card)').each(function () {
      var pid = String($(this).data('product-id'));
      if (cart[pid] && cart[pid].qty > 0) {
        var variantId = String(cart[pid].variantId).replace('gid://shopify/ProductVariant/', '');
        var item = {
          variant_id: parseInt(variantId, 10),
          quantity:   parseInt(cart[pid].qty, 10),
          title:      cart[pid].title
        };
        if (cart[pid].sellingPlan) {
          var spId = String(cart[pid].sellingPlan).replace('gid://shopify/SellingPlan/', '');
          item.selling_plan_id = parseInt(spId, 10);
        }
        lineItems.push(item);
      }
    });
    $section.find('.mrk-upsell-inline-card').each(function () {
      var pid = String($(this).data('upsell-inline-id'));
      if (inlineUpsellCart[pid] && inlineUpsellCart[pid].qty > 0) {
        var variantId = String(inlineUpsellCart[pid].variantId).replace('gid://shopify/ProductVariant/', '');
        var item = {
          variant_id: parseInt(variantId, 10),
          quantity:   parseInt(inlineUpsellCart[pid].qty, 10),
          title:      inlineUpsellCart[pid].title
        };
        if (inlineUpsellCart[pid].sellingPlan) {
          var spId = String(inlineUpsellCart[pid].sellingPlan).replace('gid://shopify/SellingPlan/', '');
          item.selling_plan_id = parseInt(spId, 10);
        }
        lineItems.push(item);
      }
    });

    var shippingAddress = differentDelivery && $form.find('#mrk-delivery-addr').val()
      ? {
          first_name:   $form.find('#mrk-cg-firstname').val() || $form.find('#mrk-firstname').val(),
          last_name:    $form.find('#mrk-cg-lastname').val()  || $form.find('#mrk-lastname').val(),
          address1:     $form.find('#mrk-cg-street').val()    || $form.find('#mrk-delivery-addr').val(),
          zip:          cgZip,
          city:         cgCity,
          country:      'Germany',
          country_code: 'DE',
          phone:        $form.find('#mrk-cg-phone').val()
        }
      : {
          first_name:   $form.find('#mrk-firstname').val(),
          last_name:    $form.find('#mrk-lastname').val(),
          address1:     $form.find('#mrk-address').val(),
          address2:     $form.find('#mrk-address-addition').val(),
          country:      'Germany',
          country_code: 'DE',
          phone:        $form.find('#mrk-phone').val()
        };

    var shopifyPayload = JSON.stringify({
      draft_order: {
        line_items: lineItems,
        customer: {
          first_name: $form.find('#mrk-firstname').val(),
          last_name:  $form.find('#mrk-lastname').val(),
          email:      $form.find('#mrk-email').val(),
          phone:      $form.find('#mrk-phone').val()
        },
        billing_address: {
          first_name:   $form.find('#mrk-firstname').val(),
          last_name:    $form.find('#mrk-lastname').val(),
          address1:     $form.find('#mrk-address').val(),
          address2:     $form.find('#mrk-address-addition').val(),
          country:      'Germany',
          country_code: 'DE',
          phone:        $form.find('#mrk-phone').val()
        },
        shipping_address: shippingAddress,
        email:    $form.find('#mrk-email').val(),
        currency: 'EUR',
        tags:     'care-order',
        note: [
          'Salutation: '       + ($form.find('#mrk-salutation').val()                    || ''),
          'Birthdate: '        + (birthdateDmy                                           || ''),
          'Insurance No: '     + ($form.find('#mrk-insurance-number').val()              || ''),
          'Care Level: '       + ($form.find('#mrk-carelevel').val()                     || ''),
          'Insurance: '        + (insuranceCompany                                       || ''),
          'Insurance Is Other: ' + String(insuranceIsOther),
          'Consultation: '     + ($form.find('input[name="consultation"]:checked').val() || ''),
          'Change Provider: '  + $form.find('#mrk-change-provider').is(':checked'),
          'Current Provider: ' + ($form.find('#mrk-current-provider').val()              || ''),
          'Signature Date: '   + (signatureDateDmy                                       || ''),
          'Submitted: '        + new Date().toISOString()
        ].join(' | '),
        note_attributes: [
          { name: 'salutation',           value: $form.find('#mrk-salutation').val()                     || '' },
          { name: 'birthdate',            value: birthdateDmy                                            || '' },
          { name: 'insurance_number',     value: $form.find('#mrk-insurance-number').val()               || '' },
          { name: 'care_level',           value: $form.find('#mrk-carelevel').val()                      || '' },
          { name: 'insurance_company',    value: insuranceCompany                                        || '' },
          { name: 'insurance_is_other',   value: String(insuranceIsOther) },
          { name: 'caregiver_first_name', value: $form.find('#mrk-cg-firstname').val()                   || '' },
          { name: 'caregiver_last_name',  value: $form.find('#mrk-cg-lastname').val()                    || '' },
          { name: 'caregiver_street',     value: $form.find('#mrk-cg-street').val()                      || '' },
          { name: 'caregiver_zip_city',   value: cgZipCity                                               || '' },
          { name: 'caregiver_phone',      value: $form.find('#mrk-cg-phone').val()                       || '' },
          { name: 'caregiver_email',      value: $form.find('#mrk-cg-email').val()                       || '' },
          { name: 'deliver_to',           value: $form.find('input[name="deliverTo"]:checked').val()     || '' },
          { name: 'different_delivery',   value: String(differentDelivery) },
          { name: 'delivery_address',     value: $form.find('#mrk-delivery-addr').val()                  || '' },
          { name: 'consultation',         value: $form.find('input[name="consultation"]:checked').val()  || '' },
          { name: 'change_provider',      value: String($form.find('#mrk-change-provider').is(':checked')) },
          { name: 'current_provider',     value: $form.find('#mrk-current-provider').val()               || '' },
          { name: 'signature_date',       value: signatureDateDmy                                        || '' },
          { name: 'submitted_at',         value: new Date().toISOString() }
        ]
      }
    });

    return {
      salutation:                    $form.find('#mrk-salutation').val(),
      firstName:                     $form.find('#mrk-firstname').val(),
      lastName:                      $form.find('#mrk-lastname').val(),
      birthdate:                     birthdateDmy,
      insuranceNumber:               $form.find('#mrk-insurance-number').val(),
      careLevel:                     $form.find('#mrk-carelevel').val(),
      insuranceCompany:              insuranceCompany,
      insuranceIsOther:              insuranceIsOther,
      insuranceOtherName:            insuranceIsOther ? ($form.find('#mrk-insurance-custom').val() || '') : '',
      caregiverFirstName:            $form.find('#mrk-cg-firstname').val(),
      caregiverLastName:             $form.find('#mrk-cg-lastname').val(),
      caregiverStreet:               $form.find('#mrk-cg-street').val(),
      caregiverZipCity:              $form.find('#mrk-cg-zip-city').val(),
      caregiverPhone:                $form.find('#mrk-cg-phone').val(),
      caregiverEmail:                $form.find('#mrk-cg-email').val(),
      Pflegebedürftige_Person:       $form.find('input[name="deliverTo"]:checked').val() === 'insured'   ? mrk_check : mrk_empty,
      Antragsteller_Ansprechpartner: $form.find('input[name="deliverTo"]:checked').val() === 'caregiver' ? mrk_check : mrk_empty,
      address:                       $form.find('#mrk-address').val(),
      addressAddition:               $form.find('#mrk-address-addition').val(),
      differentDelivery:             $form.find('#mrk-delivery-address').is(':checked'),
      deliveryFullAddress:           $form.find('#mrk-delivery-addr').val(),
      phone:                         $form.find('#mrk-phone').val(),
      email:                         $form.find('#mrk-email').val(),
      consultation:                  $form.find('input[name="consultation"]:checked').val(),
      changeProvider:                $form.find('#mrk-change-provider').is(':checked'),
      currentProvider:               $form.find('#mrk-current-provider').val(),
      signatureDate:                 signatureDateDmy,
      signatureData:                 signatureDataUrl,
      products:                      products,
      additionalProducts:            additionalProducts,
      additionalProductsSummary:     additionalProductsSummary,
      upsell_checkbox:               Object.keys(additionalProducts).length > 0 ? mrk_check : mrk_empty,
      summary_items:                 summaryItems,
      submittedAt:                   new Date().toISOString(),
      products_data: (function () {
        var arr = [];
        $section.find('.mrk-product-card:not(.mrk-upsell-inline-card)').each(function () {
          var pid = String($(this).data('product-id'));
          if (cart[pid] && cart[pid].qty > 0) {
            var entry = {
              title:     cart[pid].title,
              variantId: cart[pid].variantId,
              quantity:  cart[pid].qty
            };
            if (cart[pid].variantTitle) entry.variantTitle = cart[pid].variantTitle;
            if (cart[pid].sellingPlan)  entry.selling_plan_id = cart[pid].sellingPlan;
            arr.push(entry);
          }
        });
        $section.find('.mrk-upsell-inline-card').each(function () {
          var pid = String($(this).data('upsell-inline-id'));
          if (inlineUpsellCart[pid] && inlineUpsellCart[pid].qty > 0) {
            var entry = { title: inlineUpsellCart[pid].title, variantId: inlineUpsellCart[pid].variantId, quantity: inlineUpsellCart[pid].qty };
            if (inlineUpsellCart[pid].sellingPlan) entry.selling_plan_id = inlineUpsellCart[pid].sellingPlan;
            arr.push(entry);
          }
        });
        return arr;
      })(),
      shopify_payload: shopifyPayload
    };
  }

  $section.on('submit', '#mrk-care-form', function (e) {
    e.preventDefault();
    var ok    = true;
    var $form = $(this);
    $form.find('.mrk-field--error').removeClass('mrk-field--error');
    $form.find('.mrk-field__error').remove();
    $('#mrk-signature-error').hide();

    $form.find('[required]').each(function () {
      if (!$(this).val() || !$(this).val().trim()) {
        ok = false;
        $(this).closest('.mrk-field').addClass('mrk-field--error')
          .append('<p class="mrk-field__error">This field is required.</p>');
      }
    });

    var $em = $form.find('#mrk-email');
    if ($em.val() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test($em.val())) {
      ok = false;
      $em.closest('.mrk-field').addClass('mrk-field--error').find('.mrk-field__error').remove();
      $em.closest('.mrk-field').append('<p class="mrk-field__error">Please enter a valid email.</p>');
    }

    var $cgem = $form.find('#mrk-cg-email');
    if ($cgem.val() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test($cgem.val())) {
      ok = false;
      $cgem.closest('.mrk-field').addClass('mrk-field--error').find('.mrk-field__error').remove();
      $cgem.closest('.mrk-field').append('<p class="mrk-field__error">Please enter a valid email.</p>');
    }

    if (signatureEmpty) { ok = false; $('#mrk-signature-error').show(); }

    if (!ok) {
      var $firstErr = $form.find('.mrk-field--error').first();
      if (!$firstErr.length) $firstErr = $('#mrk-signature-error');
      $('html, body').animate({ scrollTop: $firstErr.offset().top - 100 }, 300);
      return;
    }

    if (signatureCanvas && !signatureEmpty) {
      $('#mrk-signature-data').val(signatureCanvas.toDataURL('image/png'));
    }
    submitToMake(buildPayload());
  });

  function submitToMake(payload) {
    var $submitBtns = $('#mrk-submit-btn, #mrk-submit-btn-mobile');
    $submitBtns.prop('disabled', true).text('Sending…');
    $.ajax({
      url:         MAKE_WEBHOOK_URL,
      method:      'POST',
      headers:     { 'x-make-apikey': 'sQCP2-nUHC2snHZ' },
      contentType: 'application/json',
      data:        JSON.stringify(payload),
      success: function () { goToStep(3); },
      error: function (xhr, status, err) {
        console.error('MRK Care Box – Submission error:', status, err);
        alert('There was an error submitting your application. Please try again.');
        $submitBtns.prop('disabled', false).text('Submit application');
      }
    });
  }

  renderCart();
  syncAllInlineUpsellCards();

})(jQuery);